import { createAction } from "@reduxjs/toolkit";

export const getSubscriptionSuccess = createAction("subscription/getsubscriptionSuccess")
export const getSubscriptionListSuccess = createAction("subscription/getSubscriptionListSuccess")
export const getSubscriptionRequest = createAction("subscription/getSubscriptionRequest")
export const bookSubscriptionSuccess = createAction("subscription/bookSubscription")
export const requestError = createAction("subscription/requestError")
export const defineCurrentCardSubscription = createAction("subscription/defineCurrentCardSubscription")
export const resetFondyUrl = createAction('subscription/resetFondyUrl')
export const subscriptionBookingRequest = createAction("subscription/subscriptionBookingRequest")